import React from 'react'

export default function Thead(props) {
    return (
        <thead>
            <tr>
                {props.children}
            </tr>
        </thead>
    )
}
